import {onMounted, onUnmounted} from 'vue';

type OnMessageCallback<MessageType> = (message: MessageType) => void;

export function useMicroFrontendStarter<MessageType>(onMessageReceived?: OnMessageCallback<MessageType>) {
    function onMessage(event: MessageEvent) {
        if (event.origin !== window.location.origin) {
            return;
        }
        if (onMessageReceived) {
            onMessageReceived(event.data);
        }
    }

    onMounted(() => {
        window.addEventListener('message', onMessage);
        window.parent.postMessage({from: `${window.location.pathname}${window.location.search}`, payload: 'mf:mounted'}, window.location.origin);
    });

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    });

    function postMessage<MessageType>(message: MessageType) {
        window.parent.postMessage({from: `${window.location.pathname}${window.location.search}`, payload: message}, window.location.origin);
    }

    return {
        postMessage,
    };
}
